var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "esign-box" },
    [
      _c("vue-esign", {
        ref: "esign",
        staticClass: "esign",
        attrs: {
          width: _vm.width,
          height: _vm.height,
          isCrop: _vm.isCrop,
          lineWidth: _vm.lineWidth,
          bgColor: _vm.bgColor,
          isClearBgColor: false,
          lineColor: "#666",
        },
      }),
      _c(
        "div",
        { ref: "btns", staticClass: "btns" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleReset },
            },
            [_vm._v("清空画板")]
          ),
          _vm.showCreateBtn
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.esignHandle },
                },
                [_vm._v("生成新的签名")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }